import { LOT_EXPIRY_CONFLICT_STATUS, QUANTITY_TYPES, SKU, SKU_LIKE } from 'src/constants/Constants'

export const INITIAL_RECEIVING_SEARCH_PARAMS = {
  id: '',
  client_id: '',
  arrival_date: '',
  arrival_time: '',
  department_id: '',
  asn: '',
  carrier_id: '',
  purchase_order_number: '',
  sort_method: 'desc',
  order_by: 'id',
  limit: 15,
  page: 1,
}

// statuses a receiving line can be received into
export const RECEIVING_INVENTORY_STATUSES = [
  QUANTITY_TYPES.AVAILABLE,
  QUANTITY_TYPES.QUARANTINED,
  QUANTITY_TYPES.DAMAGED,
]

export const INITIAL_FILTERS = {
  filter: SKU,
  filter_like: SKU_LIKE,
  item_type_id: 1,
}

export const RECEIVING_ITEM_NAME_STATUS = {
  1: 'IN PROGRESS',
  2: 'ON_HOLD',
  3: 'PENDING',
  4: 'VERIFICATION',
  5: 'FINALIZED',
  6: 'ERROR',
}

export const RECEIVING_PO = {
  EMPTY: 0,
  NOT_EMPTY: 1,
  NEW: 2,
}

export const VIEW_TABS = {
  ITEMS: 0,
  ATTACHMENTS: 1,
}

export const SOURCE_LABEL = {
  [LOT_EXPIRY_CONFLICT_STATUS.LOT_CONFLICT]: 'receiving',
  [LOT_EXPIRY_CONFLICT_STATUS.BRIDGE_CONFLICT]: 'bridge',
  [LOT_EXPIRY_CONFLICT_STATUS.PROXPERT_CONFLICT]: 'prox',
}

export const SOURCE_COLOR = {
  [LOT_EXPIRY_CONFLICT_STATUS.LOT_CONFLICT]: 'primary',
  [LOT_EXPIRY_CONFLICT_STATUS.BRIDGE_CONFLICT]: 'info',
  [LOT_EXPIRY_CONFLICT_STATUS.PROXPERT_CONFLICT]: 'secondary',
}

export const INITIAL_TRANSFER_TO = {
  to_receiving_id: '',
  to_client_id: '',
  to_item_id: '',
  to_uom_type_id: '',
  to_quantity: '',
  to_location_id: '',
  to_item: '',
  to_location: '',
}
